import React from 'react';

import { detailFacturePath, factureBasePath, listeFacturesPath } from './constants';
import FactureRoot from './views/FactureRoot';
import ListeFactures from './views/liste/ListeFactures';
import DetailFacture from './views/detail/DetailFacture';

export const FactureRouter = {
    path: factureBasePath,
    element: <FactureRoot />,
    handle: { title: 'Factures' },
    children: [
        {
            path: listeFacturesPath,
            element: <ListeFactures />,
            handle: { title: 'Factures - Liste' },
        },
        {
            path: detailFacturePath,
            element: <DetailFacture />,
            handle: { title: 'Factures - Détails' },
        },
    ],
};
